import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface User {
  userId: number;
  username: string;
  nickName?: string;
  avatarPath?: string;
  source?: string;
  id?: string;
  name?: string;
  _id?: string;
}

export interface UserMark {
  userId: number;
  nickName?: string;
}

interface UserState {
  // State
  currentUser: User | null;
  users: User[];
  userMarks: UserMark[];
  status: 'idle' | 'loading' | 'failed';
  error: string | null;

  // Actions (同步方法)
  setCurrentUser: (user: User | null) => void;
  setUsers: (users: User[]) => void;
  setUserMarks: (userMarks: UserMark[]) => void;
  addUserMark: (userMark: UserMark) => void;
  removeUserMark: (userId: number) => void;
  setStatus: (status: 'idle' | 'loading' | 'failed') => void;
  setError: (error: string | null) => void;
  clear: () => void;
}

export const useUserStore = create<UserState>()(
  devtools(
    (set, get) => ({
      // Initial state
      currentUser: null,
      users: [],
      userMarks: [],
      status: 'idle',
      error: null,

      // Actions (同步方法)
      setCurrentUser: (user) => set({ currentUser: user }),
      setUsers: (users) => set({ users }),
      setUserMarks: (userMarks) => set({ userMarks }),
      addUserMark: (userMark) =>
        set((state) => ({
          userMarks: [...state.userMarks.filter((um) => um.userId !== userMark.userId), userMark]
        })),
      removeUserMark: (userId) =>
        set((state) => ({
          userMarks: state.userMarks.filter((um) => um.userId !== userId)
        })),
      setStatus: (status) => set({ status }),
      setError: (error) => set({ error }),
      clear: () =>
        set({
          currentUser: null,
          users: [],
          userMarks: [],
          status: 'idle',
          error: null
        })
    }),
    {
      name: 'user-store'
    }
  )
);
